export enum Launch_Micro_Gaming {
  "hu" = "hu",
}
